import { SECURITY_SETTINGS_ACTIONS } from 'common/constants';
import { SecuritySettingsCard } from './security-settings-card.component';

export const SecuritySettingsList = () => (
  <>
    {SECURITY_SETTINGS_ACTIONS.map((item) => (
      <SecuritySettingsCard
        key={item.titleId}
        titleId={item.titleId}
        linkUrl={item.linkUrl}
        icon={item.icon}
      />
    ))}
  </>
);
